import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import PrintIcon from "@material-ui/icons/Print";
// Custom Style
import { pasStyle } from "../../../../styles/jss/components/PAS/pasStyle";
const useStyles = makeStyles((theme) => pasStyle(theme));

const PasMaster = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const { editable, setEditable, setOpenDialog } = props;

  let title = editable
    ? "PAS Highlights for Project Team Attention(Edit)"
    : "PAS Highlights for Project Team Attention";
  return (
    <Fragment>
      <Box>
        <AppBar position="static" color="transparent">
          <Toolbar>
            <Typography variant="h6" className={classes.appbarTest}>
              {title}
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
      {!editable && (
        <Grid style={{ float: "right" }}>
          
          <Tooltip title="Edit Project">
            <IconButton
              aria-label="edit"
              onClick={() => {
                setEditable(true);
              }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Print ">
            <IconButton
              aria-label="print"
              onClick={() => {
                setOpenDialog(true);
              }}
            >
              <PrintIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      )}
    </Fragment>
  );
};

export default PasMaster;
